import React from 'react';
import Card, { CardBody, CardHeader } from 'components/Card';

/**
 * Component that renders a confirmation page after a user confirms their email address (double opt-in).
 * It displays a message indicating the email confirmation is successful.
 *
 * @return {React.ReactNode} The rendered JSX element for the email confirmation page.
 */
export function OptInConfirmedPage() {
    return (
        <div className="container mx-auto py-16 px-4 !max-w-[800px]">
            <Card>
                <CardHeader>
                    <h1 className="fs-title-16 m-0">Email Confirmed</h1>
                </CardHeader>
                <CardBody>
                    <p>Thank you for confirming your email address! Your registration is now complete.</p>
                    <p className="m-0">You can now safely close this page.</p>
                </CardBody>
            </Card>
        </div>
    );
}
